import { StorageKeys } from 'shared/config/cookie'

export const OwnerIdKeyToStorage = 'owner_id'
export const DefaultKeyToStorage = StorageKeys.access
